
import stdStyle from "json/StdStyles.json"

export const SemPermissaoScreen = () => { return <div className={stdStyle.form} >Você não tem <b>permissão</b> para acessar esta página</div> }